<script>

  let isMenuActive = false
  let menu = document.getElementsByClassName('menu')

  function handleMenu(){
    if (isMenuActive) {
      isMenuActive = !isMenuActive
      menu[0].classList.add('disable')
    } else{
      isMenuActive = !isMenuActive
      menu[0].classList.remove('disable')
    }
  }

  // know whitch page the app need to show
  let page

  function handlePage(e) {
    page = e.target.id
    sayHello()

    isMenuActive = true
    handleMenu()
  }

  import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();

	function sayHello(e) {
		dispatch('message', {
			text : page
		});
	}

</script>

<nav>

  <div class="menu-wrapper">

    <img id="Home" on:click={handlePage} src="/favicon.svg" alt="Logo de l'entreprise Alex Terrieur">

    <div class="burger-button" on:click={handleMenu}>
      <div class="one burger-line"></div>
      <div class="two burger-line"></div>
      <div class="three burger-line"></div>
      <div class="foor burger-line"></div>
    </div>
  </div>

  <ul class="navigation">
    <div class="nav-wrapper">
      <li id="Realisations" on:click={handlePage}>Nos réalisations</li>
      <li id="Inside" on:click={handlePage}>Décoration intérieur</li>
    </div>
    <div class="nav-wrapper">
      <li id="Outside" on:click={handlePage}>Aménagement extérieur</li>
      <li id="Contact" on:click={handlePage}>Nous contacter</li>
    </div>
  </ul>

  <div id="menu" class="menu disable">
    <ul class='nav-list'>
      <li id="Realisations" on:click={handlePage}>Nos réalisations</li>
      <li id="Inside" on:click={handlePage}>Décoration intérieur</li>
      <li id="Outside" on:click={handlePage}>Aménagement extérieur</li>
      <li id="Contact" on:click={handlePage}>Nous contacter</li>
    </ul>
  </div>

</nav>

<style>

  .menu-wrapper{
    display: flex;
    justify-content: flex-end;
    align-items: center;

    height: 90px;
    width: 100%;

    position: relative;

    padding: 20px;
  }

  img{
    position: absolute;

    top: 50%;
    left: 50%;

    transform: translate(-50%, -50%);

    cursor: pointer;

    z-index: 100;
  }

  .burger-button{
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    cursor: pointer;

    z-index: 100;
  }

  .burger-line{
    height: 5px;

    background: #3D3D3D;

    border-radius: 30px;

    margin-bottom: 2px;

    width: 32px;
    transition: all .4s ease-out;
  }

  .two{
    width: 19px;
  }
  .three{
    width: 8px;
  }
  .foor{
    width: 25px;
  }

  .burger-button:hover .two{
    width: 32px;
    transition: all .4s ease-out;
  }
  .burger-button:hover .three{
    width: 32px;
    transition: all .4s ease-out;
  }
  .burger-button:hover .foor{
    width: 32px;
    transition: all .4s ease-out;
  }

  .nav-list{
    list-style: none;

    position: absolute;

    width: 100vw;
    height: 100vh;

    top: 0;
    left: 0;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    font-size: 2rem;

    background: white;

    z-index: 99;
  }

  .nav-list li{
    margin: 20px 0;

    cursor: pointer;

    text-align: center;
  }

  .menu{
    transition: all .4s ease-out;
  }

  .disable{
    transform: translateX(100vh);

    transition: all .4s ease-out;
  }

  .navigation{
    display: none;
  }

  @media screen and (min-width: 700px){
    .menu, .burger-button{
      display: none;
    }

    .navigation{
      display: flex;
      justify-content: space-between;

      list-style: none;

      width: 100%;

      position: absolute;

      top: 35px;

      padding: 0 30px;
    }

    .nav-wrapper{
      display: flex;
    }

    .navigation li{
      cursor: pointer;
      width: 20vw;

      align-self: center;

      text-align: center;
    }

    .navigation li:hover{
      color: #7C7C7C;
    }
  }

</style>